import * as React from 'react';
import loadMore from 'owa-mail-reading-pane-store/lib/actions/loadMore';
import strings from 'owa-strings/owa-mail-strings';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { observer } from 'mobx-react';
import { ClientItemId } from 'owa-client-ids';
import { IButtonStyles } from 'office-ui-fabric-react/lib';

export interface MailListItemExpansionLoadMoreButtonProps {
    conversationId: ClientItemId;
    isLoadMoreInProgress: boolean;
    isSingleLineView: boolean;
    isNewestOnBottom: boolean;
}

const styles = require('./MailListItemExpansionLoadMoreButton.scss');
const classNames = require('classnames/bind');

export default observer(function MailListItemExpansionLoadMoreButton(
    props: MailListItemExpansionLoadMoreButtonProps
) {
    const loadMoreStyles: IButtonStyles = {
        root: classNames(
            styles.loadMoreButtonRoot,
            props.isSingleLineView ? styles.singleLineLeftPadding : styles.threeColumnLeftPadding
        ),
        textContainer: styles.loadMoreText,
        flexContainer: styles.loadMoreButtonFlexContainerStyles,
        label: styles.loadMoreButtonLabel,
    };

    return props.isLoadMoreInProgress ? (
        <div
            className={classNames(
                styles.loadCommon,
                props.isSingleLineView
                    ? styles.singleLineLeftPadding
                    : styles.threeColumnLeftPadding
            )}>
            <div className={styles.loadingFlexContainer}>
                <Spinner />
                <span className={styles.loadingText}>{strings.loading}</span>
            </div>
        </div>
    ) : (
        <DefaultButton
            onClick={evt => onLoadMore(evt, props.conversationId)}
            styles={loadMoreStyles}
            text={strings.loadMore}
        />
    );
});

const onLoadMore = (event: React.MouseEvent<EventTarget>, conversationId: ClientItemId) => {
    event.stopPropagation();
    loadMore(conversationId);
};
